<template>

	<span v-if="loaded=='true'">

		<main class="col-xs-12 npd" v-if="programa.acf.imagen_horizontal!=false">
			<img v-bind:src="programa.acf.imagen_horizontal.sizes['1440x446']" alt="" width="100%">
		</main>
		<section class="col-xs-12 block">
			<div class="container">
				<div class="row">
					<h2 v-html="programa.title.rendered"></h2>
					<div class="col-xs-12">
						<figure class="col-xs-12 col-md-3 persona" v-if="loaded_locutores=='true'" v-for="locutor in locutores">
							<img
								v-if="locutor.better_featured_image.hasOwnProperty('media_details')"
								v-bind:src="locutor.better_featured_image.media_details.sizes['530x626'].source_url"
								alt="">
							
						</figure>
						<figure class="col-xs-12 col-md-3 persona" v-else>
							<!-- NONE -->
						</figure>
						<div class="col-xs-12 col-md-5 desprog">
							<p v-html="programa.content.rendered"></p>
							<span v-if="loaded_locutores=='true'" v-for="locutor in locutores">
								<router-link :to="{ name: 'locutor', params: { locutor: locutor.slug }}" class="btn celeste">
								LEER MÁS SOBRE EL LOCUTOR
							</router-link>
							</span>
						</div>
						<div class="col-xs-12 col-md-3">
							<div class="col-xs-12 npd horario" v-if="programa.acf.hasOwnProperty('horarios_texto')">
								<div class="hor_head">
									<h3>HORARIOS</h3>
								</div>
								<p v-html="programa.acf.horarios_texto"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<div class="col-xs-12 block reproductor programacion" v-if="loaded_audios==='true'">
			<div class="container">
				<div class="row">
					<div class="player__playlist">
						<div class="compartir__player">
							<button><i class="icon share"></i></button>
							<ul>
								<ul>
								<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+programa.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
								<li><a v-bind:href="'https://twitter.com/share?url='+programa.link+'&text='+programa.title.rendered" target="_blank"><i class="fa fa-twitter"></i></a></li>
								<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+programa.link"><i class="fa fa-whatsapp"></i></a></li>
							</ul>
							</ul>
						</div>
						<a href="#" class="fav__player"><i v-bind:programa="programa.id" class="icon star"></i></a>
						<ul class="playlist">
							<li v-for="audio in audios" v-if="audio.better_featured_image.hasOwnProperty('media_details')" v-bind:data-cover="audio.better_featured_image.media_details.sizes.thumbnail.source_url" v-bind:data-descripcion="audio.soloexcerpt" class="col-xs-12 npd">
								<a v-bind:href="audio.post_meta_fields._enclosure_mp3">
									<span class="titulo" v-html="audio.title.rendered"></span>
									<span class="autor" v-html="audio.acf.locutor[0].post_title"></span>
									<span class="fecha" v-html="audio.fechaconformatocorto"></span>
									<span class="duracion" v-html="audio.post_meta_fields._duration.dur"></span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>



		
		<section class="hidden-xs hidden-sm col-md-12 block" v-if="loaded_programas=='true'">
			<div class="container">
				<div class="row">
					<h2>OTROS PROGRAMAS</h2>
					<!-- ITEM -->
					<div class="col-xs-12 col-xs-6 col-md-3 progitem" v-for="programa in programas">
						<div class="col-xs-12 npd progitem__wrap paused">
							<router-link :to="{ name: 'programa', params: { elprograma: programa.slug }}" class="toint">
								<figure>
									<img v-if="programa.better_featured_image!='false'" v-bind:src="programa.better_featured_image.media_details.sizes.medium.source_url" alt="">
									<img v-else v-bind:src="theme_url+'/html/assets/img/programa.jpg'" alt="">
									
									<div class="flex-centermid progitem__des">
										 <p><i class="icon time"></i><span v-html="programa.acf.horarios_texto"></span></p>
									</div>

								</figure>
								<h3 v-html="programa.title.rendered"></h3>
							</router-link>
							<!--
							<div class="reflexiones__title paused">
								<button v-if="programa.post_meta!=null" v-bind:audio="programa.post_meta._enclosure_mp3" class="reflexiones__player flex-centermid btn">
							 	<i class="icon play-mini-white"></i>
								</button>
								<button v-else class="flex-centermid btn">
							 		<i class="icon play-mini-white"></i>
								</button>
							</div>
						-->
						</div>
					</div>

				</div>
			</div>
		</section>

	</span>


</template>





<script>
export default {
	mounted: function() {
		const vm = this;
		if ( vm.$route.params.elprograma ) {
			vm.getPrograma( vm.$route.params.elprograma );
			vm.$store.commit( 'rtChangeTitle', vm.$route.params.elprograma );
		}

	},
	watch: {
		// call method if the route changes
		'$route': 'reInitialize'
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			programa: {},
			programas: {},
			// locutor: {},
			locutores: {},
			audios: {},
			loaded: 'false',
			loaded_programas: 'false',
			// loaded_locutor: 'false',
			loaded_locutores: 'false',
			loaded_audios: 'false',
		};
	},
	methods: {
		reInitialize: function() {
			const vm = this;
			if ( vm.$route.params.elprograma ) {
				vm.getPrograma( vm.$route.params.elprograma );
			}
		},
		getPrograma: function( elslug ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/programas', {
				params: { slug: elslug }
			} )
			.then( ( res ) => {
				vm.programa= res.data[0];
				vm.loaded = 'true';
				vm.getProgramas(res.data[0].id);
				if(typeof res.data[0].acf.locutor == 'object'){
					// vm.getLocutor(res.data[0].acf.locutor[0].post_name);
					vm.getLocutores(res.data[0].acf.locutor);
				}
				vm.getAudios(vm.programa.id);
				vm.$store.commit( 'rtChangeTitle', vm.programa.title.rendered );

			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getProgramas: function( esteprograma  ) {
			const vm = this;
			vm.loaded_programas = 'false';
			vm.$http.get( 'wp/v2/programas',{
				params: { per_page: 4, exclude: esteprograma, orderby:'rand' }
			})
			.then( ( res ) => {
				vm.programas = res.data;
				vm.loaded_programas = 'true';
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					setTimeout(function(){
						jQuery('div.reflexiones__title').on('click','button.reflexiones__player', function(event) {
							event.preventDefault();
							var self=this;
							var audio=jQuery('#elementodeaudio');
							var estado=jQuery(self).parent().hasClass('paused');
							if(estado!=true){
								jQuery('div.reflexiones__title').addClass('paused');
								jQuery(audio).trigger('pause');
							} else {
								jQuery(audio).prop('src',jQuery(self).attr('audio'));
								jQuery(self).parent().removeClass('paused');
								jQuery(audio).trigger('play');

							}
						});
					},500);
					init_attach();	
					
				});

			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getLocutores: function( locutores ) {
			const vm = this;
			
			var ids='';
			locutores.map(function(value, key) {
				ids=ids+','+value.ID;
			});
			ids=ids.substring(1);
			vm.loaded_locutores = 'false';
			vm.$http.get( 'wp/v2/locutores', {
				params: { include: ids }
			} )
			.then( ( res ) => {
				vm.locutores= res.data;
				vm.loaded_locutores = 'true';
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getLocutor: function( elslug ) {
			const vm = this;
			vm.loaded_locutor = 'false';
			vm.$http.get( 'wp/v2/locutores', {
				params: { slug: elslug }
			} )
			.then( ( res ) => {
				vm.locutor= res.data[0];
				vm.loaded_locutor = 'true';
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getAudios: function( programaid ) {
			const vm = this;
			vm.loaded_audios = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { elprograma: programaid, per_page:10,category:7 }
			} )
			.then( ( res ) => {
				vm.audios= res.data;
				// window._data=res.data;
				if(res.data.length>0){
					vm.loaded_audios = 'true';
					console.log(vm.loaded_audios);
					console.log(vm.audios);
				}
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		}
	}

};
</script>



// WEBPACK FOOTER //
// programa.vue?31ac6d85